// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"79":"866c9ab4213bb19f","309":"7f85d97b4137ab91"}[chunkId] + ".js";
};